/**
 * @ngdoc directive
 * @name cart-confirmation
 *
 * @description
 * Cart summary component
 */
module.directive('cartConfirmation', function() {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            reminder: '=',
            cart: '=',
            internshipDetails: '=?',
            type: '@?',
            button: '@?'
        },
        controller: ['$rootScope', '$scope', '$state', function($rootScope, $scope, $state) {
            $scope.order = function () {
                if (!$scope.pending) {
                    $scope.pending = true;
                    $state.go('order.login');
                }
            };
            $scope.config = $rootScope.config;
            
        }],
        templateUrl: 'src/components/cart-confirmation/cart-confirmation.html'
    };
});
